module.exports = __webpack_public_path__ + "static/img/newyorktimes.e9fbf1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/old/newyorktimes.png
// module id = n8WA
// module chunks = 0